import React, { useState, useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { AppContext, AppConsumer } from "../../providers/appProvider";
import { createStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useExternalScript } from "./useExternalScript";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect, useSelector, useDispatch } from 'react-redux';
import { actionCreators } from "../../store/NavItems";

import clsx from "clsx";
import {
    Grid,
    Paper,
    Typography,
    CircularProgress,
} from "@material-ui/core";

import GoBackRecharge from "./GoBackRecharge";

const PAYMENT_STORAGE_KEY = "jr-liqpay-payment";

const parsePaymentFromSearch = (search) => {
    const params = new URLSearchParams(search || "");
    const amount = params.get("amount");
    const docId = params.get("docId");
    const title = params.get("title");
    const orderDesc = params.get("order_desc");

    if (!amount && !docId) {
        return null;
    }

    return {
        amount: amount ? parseFloat(amount) : undefined,
        docId: docId || undefined,
        title: title || "",
        order_desc: orderDesc || "",
    };
};

const readStoredPayment = () => {
    try {
        const raw = window.sessionStorage.getItem(PAYMENT_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        console.log("Failed to read stored LiqPay payment", error);
        return null;
    }
};

const persistPayment = (payment) => {
    try {
        if (!payment) {
            window.sessionStorage.removeItem(PAYMENT_STORAGE_KEY);
            return;
        }

        window.sessionStorage.setItem(PAYMENT_STORAGE_KEY, JSON.stringify(payment));
    } catch (error) {
        console.log("Failed to persist LiqPay payment", error);
    }
};

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      // flexGrow: 1,
      paddingTop: theme.spacing(8),
      [theme.breakpoints.down("xs")]: {            
        paddingTop: theme.spacing(1),
      },
      
    },
    paper: {
      padding: theme.spacing(3, 1),
      boxShadow:
        "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
    },
    paymentbox: {
        minHeight: 355,
        borderRadius: "1rem",
    },
    header: {
      fontWeight: 300,
      marginBottom: theme.spacing(2),
    },
    liqpay:{
        // padding: theme.spacing(2),
        // border: `1px solid ${theme.palette.divider}`,        
        // borderRadius: theme.spacing(4),
        [theme.breakpoints.down("xs")]: {            
            margin: theme.spacing( 0, -1, 0 -1),
          },
    },
  })
);

const Liqpay = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("xs"));
    const auth = useContext(AppContext);
    const [token, setToken] = useState();
    const [errorText, setErrorText] = useState("");
    const history = useHistory();
    const payment =
        props.location?.state?.payment ||
        parsePaymentFromSearch(props.location?.search) ||
        readStoredPayment();

    const dispatch = useDispatch();     
    // const appLayout = useSelector((state) =>  state.appLayout );
    
    
    const status = useExternalScript("//static.liqpay.ua/libjs/checkout.js?v2.0.0");

    useEffect(() => {
        if (props.location?.state?.payment) {
            persistPayment(props.location.state.payment);
        }
    }, [props.location]);

    // Get token
    useEffect(() => {
        if (!auth) return;

        function fetchUser() {
        auth.getUser().then(async (user) => {
            let token = null;
            if (user != null) {
            token = `Bearer ${user.access_token}`;
            }
            setToken(token);
        });
        }
        fetchUser();
    }, [auth]);

    // Liqpay checkot
    useEffect(() => {
        if(!token) return;
        if(!payment) return;

        //console.log('PAYMENT', payment);
        if(!window.LiqPayCheckout) return;

        setErrorText("");

        const url = payment.docId ? 
                    `/api/v1.0/liqpay/payorder/${payment.docId}` : 
                    `/api/v1.0/liqpay/recharge?amount=${payment.amount}`;
        fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then(async (response) => {
            if (!response.ok) {
                throw new Error(await response.text());
            }

            return response.json();
        })
            .then((data) => {
                if (data) {
                    const liqpayData = data?.Data ?? data?.data;
                    const liqpaySignature = data?.Signature ?? data?.signature;
                    const liqpayLanguage = data?.Language ?? data?.language;

                    if (!liqpayData || !liqpaySignature) {
                        setErrorText("LiqPay payload is empty");
                        return;
                    }
                    
                    if(process.env.NODE_ENV === "development")
                        console.log("Payment data", data);                        
                    window.LiqPayCheckout.init({
                        data: liqpayData,
                        signature: liqpaySignature,
                        embedTo: "#liqpay_checkout",
                        mode: "embed",
                        language: liqpayLanguage,
                }).on("liqpay.callback", function (data) {
                    if(process.env.NODE_ENV === "development")                                                        
                        console.log("liqpay.callback data", data);

                    if(data){                        
                        if( data.result === "ok" && (data.status === "success" ||  data.status === "sandbox") && data.dae){
                            setTimeout(() => {
                                dispatch(actionCreators.getCustomer(token));
                            }, 2000);

                            const daeJSON = atob(data.dae);                        
                            const dae = JSON.parse(daeJSON);                                                        
                            if(dae && dae.baseId){                                
                                history.push(`/orderfin/reg/pp/${dae.baseId}`); 
                            }
                        }                        
                }
            }).on("liqpay.ready", function (data) {
                console.log("!!! LIQPAY READY", data);                 
                if(isXs)                                                                                  
                    window.scrollTo({top: 299, behavior: "instant"});
                else
                    window.scrollTo({top: 170, behavior: "smooth"});

            }).on("liqpay.close", function (data) {                    
                console.log("liqpay.close", data);
            });

              
            }
          })
          .catch((error) => {
            console.log("Error", error);
            setErrorText(error.message || "Failed to initialize LiqPay");
          })
          .finally(() => {});
    }, [dispatch, history, isXs, payment, status, token]);

  return (
        <AppConsumer>
        {() => (
            <>
            <Helmet>
                
            </Helmet>
            <div className={classes.root}>                
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={0}
                >
                    <Grid item xs={12} sm={11} md={7}>
                        <GoBackRecharge />
                        <Paper className={ clsx(classes.paper, classes.paymentbox)} elevation={0}>
                        {!window.LiqPayCheckout && 
                            <Typography component='div' display="block" align="center" style={{paddingTop: 64}}>
                            <CircularProgress size={80} />
                            </Typography>                
                        }

                        {!payment && (
                            <Typography color="error" align="center">
                                Payment session is missing. Please restart the payment flow.
                            </Typography>
                        )}

                        {errorText && (
                            <Typography color="error" align="center">
                                {errorText}
                            </Typography>
                        )}
                        
                        <div className={classes.liqpay} id="liqpay_checkout"></div>                            
                        </Paper>
                    </Grid>

                </Grid>                
            </div>
            </>
        )}
        </AppConsumer>
    );  
};
export default connect(
    state => state.appLayout,
    dispatch => bindActionCreators(actionCreators, dispatch)
  )(Liqpay)
  
// export default Liqpay
